import { UserSettingsFeatures } from "./UserSettingsFeatures"
import { UserSettingsRegional } from "./UserSettingsRegional"
import { UserSettingsOther } from "./UserSettingsOther"

export class UserSettings {
  features: UserSettingsFeatures = new UserSettingsFeatures()
  isAdminLoggedIn: boolean = false
  regs: UserSettingsRegional = new UserSettingsRegional()
  settings: UserSettingsOther = new UserSettingsOther()
}
